import React, { useMemo } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { ProductsHeader } from 'src/components/products-header';
import LayoutButtons from 'src/components/layout-buttons';
import { LayoutMode } from 'src/components/layout-buttons/types';

import { MAX_RESULTS } from '../../constants';

type Props = {
  activeLayout?: LayoutMode;
  setLayout: (layout: LayoutMode) => void;
  productsCount?: number | null;
};

export const SearchResultsProductsHeader = (props: Props) => {
  const { market, t } = useAppContext();

  const { activeLayout, productsCount = 0, setLayout } = props;

  const supportedViewModes = useMemo(
    () => [LayoutMode.GRID, LayoutMode.LIST, LayoutMode.COMPACT_LIST],
    []
  );

  const count =
    (productsCount || 0) >= MAX_RESULTS
      ? `${MAX_RESULTS.toLocaleString(market.localeStandard)}+`
      : (productsCount || 0).toLocaleString(market.localeStandard);

  return (
    <>
      <ProductsHeader
        displayOptions={
          <>
            <LayoutButtons
              layoutModes={supportedViewModes}
              activeLayout={activeLayout || LayoutMode.GRID}
              setLayout={currentLayout => setLayout(currentLayout)}
            />
          </>
        }
        title={`${t('search', 'products.title')} (${count})`}
      />
    </>
  );
};
